import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=3cd3f97a&scoped=true"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=3cd3f97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd3f97a",
  null
  
)

export default component.exports